import React from 'react';

const CodeSentIcon = () => {
  return (
    <svg className='iconTop' width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='26' y='42' width='68' height='22' rx='4' stroke='var(--theme-primary, #810ea9)' strokeWidth='2.5' strokeLinejoin='round' />
      <path
        d='M43 53c-2.872.624-3.377 1.129-4 4-.623-2.872-1.128-3.377-4-4 2.871-.623 3.377-1.128 4-4 .623 2.872 1.128 3.377 4 4zM57 53c-2.872.624-3.377 1.129-4 4-.623-2.872-1.128-3.377-4-4 2.871-.623 3.377-1.127 4-4 .623 2.873 1.128 3.377 4 4zM71 53c-2.872.624-3.377 1.129-4 4-.623-2.872-1.128-3.377-4-4 2.871-.623 3.377-1.127 4-4 .623 2.873 1.128 3.377 4 4zM85 53c-2.872.624-3.377 1.129-4 4-.623-2.872-1.128-3.377-4-4 2.871-.623 3.377-1.127 4-4 .623 2.873 1.128 3.377 4 4z'
        fill='var(--theme-primary, #810ea9)'
        stroke='var(--theme-primary, #810ea9)'
        strokeWidth='.75'
        strokeLinejoin='round'
      />
      <path
        d='M98 24H22a6 6 0 0 0-6 6v46a6 6 0 0 0 6 6h7a4 4 0 0 1 4 4v9.652c0 1.708 2.004 2.63 3.302 1.518l16.575-14.207A4 4 0 0 1 55.48 82H98a6 6 0 0 0 6-6V30a6 6 0 0 0-6-6z'
        stroke='#000'
        strokeWidth='2.5'
      />
    </svg>
  );
};

export default CodeSentIcon;
